<template>
  <div class="card product-card">
    <div v-if="productImageUrl" class="card-img-container">
      <img :src="productImageUrl.url" alt="Produktbillede" class="card-img" />
    </div>
    <div v-else class="card-img-container">
      <img
        :src="require('/src/assets/graphics/chemistry-icon.svg')"
        alt="Placeholder, produktbillede"
        class="card-img"
      />
    </div>

    <div class="card-img-overlay" v-if="productCard.reaction.name_d">
      <div
        :class="{
          'product-reaction': true,
          'product-reaction-light': productCard.reaction.name_d
            ? productCard.reaction.name_d.toLowerCase().includes('indskærpelse')
            : false,
          'product-reaction-medium': productCard.reaction.name_d
            ? productCard.reaction.name_d.toLowerCase().includes('forbud')
            : false,
          'product-reaction-dark': productCard.reaction.name_d
            ? productCard.reaction.name_d.toLowerCase().includes('påbud')
            : false,
        }"
      >
        {{ productCard.reaction.name_d }}
      </div>
    </div>
    <div>
      <p class="product-name">{{ productCard.name }}</p>
      <p class="product-type" v-if="showCategory">
        {{ getProductCategories().length > 1 ? "Kategorier:" : "Kategori:" }}

        <span
          v-for="(category, index) in getProductCategories()"
          :key="category.id"
          class="inherit-link-styling"
        >
          <span v-if="index > 0">; </span>
          <span v-if="category.id">
            {{ category.name }}
          </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["productCard", "showCategory"],
  data() {
    return {
      productImageUrl: "",
    };
  },
  mounted() {
    let specificFirstImage = false;
    if (this.productCard.productPictures.length > 0) {
      this.productCard.productPictures.forEach((element) => {
        if (element.productPictureCategory.name === "PRODUKT") {
          specificFirstImage = true;
          if (this.productImageDict[element.pictureId]) {
            this.productImageUrl = this.productImageDict[element.pictureId];
          } else {
            this.getProductPicture(element.pictureId, element.source);
          }
        }
      });
      if (!specificFirstImage) {
        let element = this.productCard.productPictures[0];
        if (this.productImageDict[element.pictureId]) {
          this.productImageUrl = this.productImageDict[element.pictureId];
        } else {
          this.getProductPicture(element.pictureId, element.source);
        }
      }
    }
  },
  methods: {
    getProductPicture(pictureId, pictureSource) {
      axios
        .get(process.env.VUE_APP_PRODUCTS_API + "picture/" + pictureId, {
          responseType: "blob",
        })
        .then((response) => {
          // console.log(
          //   "Response from " +
          //     process.env.VUE_APP_PRODUCTS_API +
          //     "picture/" +
          //     pictureId,
          //   response.data
          // );
          this.productImageUrl = {
            url: URL.createObjectURL(response.data),
            source: pictureSource,
          };
          this.$store.commit("products/addImageUrl", {
            id: pictureId,
            pictureObject: this.productImageUrl,
          });
        })
        .catch((error) => {
          console.log(
            "Error from " +
              process.env.VUE_APP_PRODUCTS_API +
              "picture/" +
              pictureId,
            error
          );
          this.productImageUrl = "";
        });
    },
    // getProductCategories() {
    //   let categoryArray = [];
    //   if (this.productCard.productCategoryRelations.length > 0) {
    //     this.productCard.productCategoryRelations.forEach((element) => {
    //       if (element.productCategoryType.name_d) {
    //         categoryArray.push(" " + element.productCategoryType.name_d.trim()); //Includes a space to separate categories in display
    //       }
    //     });
    //   } else {
    //     categoryArray.push(" Ikke angivet"); //Includes a space to separate from title
    //   }
    //   return categoryArray;
    // },
    getProductCategories() {
      let categoryArray = [];
      if (this.productCard.productCategoryRelations.length > 0) {
        this.productCard.productCategoryRelations.forEach((element) => {
          if (element.productCategoryType.name_d) {
            categoryArray.push({
              name: element.productCategoryType.name_d.trim(),
              id: element.productCategoryType.id,
            });
          }
        });
      } else {
        categoryArray.push({ name: "Ikke angivet", id: null });
      }
      return categoryArray;
    },
  },
  computed: {
    productImageDict: {
      get() {
        return this.$store.state.products.productImageDict;
      },
    },
  },
};
</script>

<style lang="scss">
.card.product-card {
  cursor: pointer;
  &:hover,
  &:focus {
    transform: scale(1.05);
  }
}
.product-reaction {
  position: absolute;
  color: white;
  font-family: oxygen-bold;
  font-size: 0.85em;
  padding: 3px 10px;
  left: 0;
  top: 0;
  background: var(--mediumgreen);
  border-radius: 0;
}
.product-reaction-dark {
  background: var(--darkgreen);
}
.product-reaction-medium {
  background: var(--deepgreen);
}
.product-reaction-light {
  background: var(--mediumgreen);
}
.product-name {
  font-size: 1em;
  padding: 15px 0 0 0;
  margin: 0;
  font-family: oxygen-bold;
}
.product-type {
  font-size: 0.85em;
  padding: 5px 0 0 0;
  margin: 0;
  color: black;
}
.product-card .card-img {
  border-radius: 0px;
}
.card-img-container {
  position: relative;
  width: 100%;
  padding-bottom: 85%;
}
.card-img-container .card-img {
  position: absolute; /* Take your picture out of the flow */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0; /* Make the picture taking the size of it's parent */
  width: 100%;
  height: 100%;
  object-fit: cover; /* Equivalent of the background-size: cover; of a background-image */
  object-position: center;
}
</style>
